import { CoreDomainService } from '@client/app/core/services/domain/core-domain.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';

export const removeDomainResolver = () => {
    return {
        token: 'removeDomain',
        deps: [CoreDomainService, MonEventService],
        resolveFn: async (
            coreDomainService: CoreDomainService,
            monEventService: MonEventService,
        ): Promise<void> => {
            coreDomainService.setDomain(null);
            coreDomainService.removeDomainGroup();
            await monEventService.run('changed-domain');
        },
    };
};
